<template>
  <div class="group-search-item" v-bind:wait="100" >{{item == null ? '' : item.text}}</div>
</template>

<script>
export default {
  name: "GroupSearchItem",
  props: {
    item: {required: true},
    searchText: {required: true}
  }
}
</script>

<style scoped>

  .group-search-item {
    font-size: 1rem;
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/GroupSearchItem.vue